export const coursesByCategoryLimit = 8;
export const latestCoursesLimit = 8;
export const randomSpeakersLimit = 8;
export const relatedCoursesLimit = 10;
